export default "__VITE_ASSET__b8966cfa__"